export const DEVICE_UID = 'device_uid';
